import { Icon } from '@iconify/react';
import type { FC } from 'react';

import type { Industry } from '@/services/resume-checker';

import Text from '../Text';
import { ToggleGroup, ToggleItem } from '../ui/toggle-group';

type Props = {
  value: Industry;
  onChange: (value: Industry) => void;
};

export const industryStyles: {
  iconColor: string;
  icon: string;
  industry: Industry;
  label: string;
}[] = [
  {
    industry: 'TECH',
    icon: 'mdi:laptop',
    iconColor: 'text-secondary-500',
    label: 'Technology',
  },
  {
    industry: 'HEALTH',
    icon: 'mdi:heart-pulse',
    iconColor: 'text-jb-alert-400',
    label: 'Healthcare',
  },
];

const SelectIndustryInput: FC<Props> = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-2">
      <Text
        variant="jb-body-small"
        className="font-semibold text-jb-neutral-700"
      >
        Select your industry
      </Text>
      <ToggleGroup
        variant="unstyled"
        type="single"
        onValueChange={(next: Industry) => {
          if (next) onChange(next);
        }}
        value={value}
        className="flex w-full gap-3"
      >
        {industryStyles.map(({ icon, iconColor, industry, label }) => (
          <ToggleItem
            key={industry}
            value={industry}
            className="flex flex-1 flex-col items-center gap-3 rounded-lg border-2 border-jb-neutral-400 p-2 transition-all hover:border-jb-primary-300 data-[state=on]:border-jb-primary-500"
          >
            <div className="flex items-center justify-center rounded-xl bg-jb-neutral-300 p-2">
              <Icon icon={icon} className={iconColor} fontSize={20} />
            </div>
            <Text variant="jb-body-medium" className="font-semibold">
              {label}
            </Text>
          </ToggleItem>
        ))}
      </ToggleGroup>
    </div>
  );
};

export default SelectIndustryInput;
